var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2487 23.2168V4.7835C12.2487 3.0335 11.502 2.3335 9.64703 2.3335H4.9337C3.0787 2.3335 2.33203 3.0335 2.33203 4.7835V23.2168C2.33203 24.9668 3.0787 25.6668 4.9337 25.6668H9.64703C11.502 25.6668 12.2487 24.9668 12.2487 23.2168Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 12.7168V4.7835C25.6667 3.0335 24.92 2.3335 23.065 2.3335H18.3517C16.4967 2.3335 15.75 3.0335 15.75 4.7835V12.7168C15.75 14.4668 16.4967 15.1668 18.3517 15.1668H23.065C24.92 15.1668 25.6667 14.4668 25.6667 12.7168Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 23.2165V21.1165C25.6667 19.3665 24.92 18.6665 23.065 18.6665H18.3517C16.4967 18.6665 15.75 19.3665 15.75 21.1165V23.2165C15.75 24.9665 16.4967 25.6665 18.3517 25.6665H23.065C24.92 25.6665 25.6667 24.9665 25.6667 23.2165Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.d4a1dfa7859e77c8deb723b0958c8472.svg";
export { ForwardRef as ReactComponent };